import { z } from 'zod';

export const FetchKaiserUrlPayloadDTO = z.object({
  domainSessionId: z.string(),
});

// eslint-disable-next-line no-redeclare
export type FetchKaiserUrlPayloadDTO = z.infer<typeof FetchKaiserUrlPayloadDTO>;

export const FetchKaiserUrlResponseDTO = z.object({
  domainSessionId: z.string(),
  microSiteUrl: z.string().url(),
});

// eslint-disable-next-line no-redeclare
export type FetchKaiserUrlResponseDTO = z.infer<
  typeof FetchKaiserUrlResponseDTO
>;
